import { createBrowserRouter, RouteObject } from "react-router-dom";
import ListOfSuspensions from "./companySuspension/features/ListOfSuspensions";
import Mailbox from "./email/mailbox/features/Mailbox";
import MailboxDetails from "./email/mailbox/features/MailboxDetails";
import PublicCertificateDownloadForm from "./publicCertificateDownload/features/form/PublicCertificateDownloadForm";
import { adminPaths } from "./routes/AdminRoutes";
import { applicationPaths } from "./routes/ApplicationRoutes";
import { beneficiaryPaths } from "./routes/BeneficiaryRoutes";
import { businessPaths } from "./routes/BusinessRoutes";
import { cashierPaths } from "./routes/CashierRoutes";
import { certificatePaths } from "./routes/CertificateRoutes";
import { chamberRoutes } from "./routes/ChamberRoutes";
import { creditCard } from "./routes/CreditCardRoutes";
import { followCompanyPaths } from "./routes/FollowCompanyRoutes";
import { namePurchase } from "./routes/NamePurchaseRoutes";
import { nonGemiPaths } from "./routes/NonGemiRoutes";
import { paymentPaths } from "./routes/PaymentRoutes";
import { region } from "./routes/RegionRoutes";
import RouteProtector from "./routes/RouteProtector";
import PersistentDrawerLeft from "./shared/Layouts/Sider/Drawer/Drawer";
import OauthHandler from "./shared/Layouts/oauthHandle/OauthHandler";
import CompanyNameApproverLogin from "./welcome/features/companyNameApproverLogin/CompanyNameApproverLogin";
import RegistrationForm from "./welcome/features/registrationForm/RegistrationForm";
import TaxisRegister from "./welcome/features/taxisRegister/taxisRegister";
import CheckYourEmail from "./welcomeNonGemi/features/checkYourEmail/CheckYourEmail";
import NonGemiRegistrationForm from "./welcomeNonGemi/features/index/NonGemiRegistrationForm";
import ValidateEmail from "./welcomeNonGemi/features/validateEmail/ValidateEmail";
import VisaCardMore from "./welcome/features/cardMore/VisaCardMore";
import MasterCardMore from "./welcome/features/cardMore/MasterCardMore";
import Cookies from "./welcome/features/cookies/Cookies";
import PrivacyPolicies from "./welcome/privacyPolicies/PrivacyPolicies";
import Error502 from "src/shared/features/errorPages/Error502";
import BrowserBackProvider from "./shared/context/BrowserBack";
import { empaPaths } from "./routes/EmpaRoutes";
import LandPage from "src/welcome/features/LandPage/LandPage";
import NotFoundPage from "src/shared/features/errorPages/NotFound";
import DocumentDownloadPage from "src/shared/features/documentDownload/DocumentDownloadPage";
import Reminder from "./welcome/features/reminderForm/Reminder";
import OauthHandlerForReminder from "./welcome/features/reminderForm/OauthHandlerForReminder";
import ResetPasswordForm from "./welcome/features/reminderForm/ResetPasswordForm";
import ResetPassCheckEmail from "./welcome/features/reminderForm/ResetPassCheckEmail";
import { complaintPaths } from "./routes/ComplaintRoutes";
import { sampleInspectionPaths } from "./routes/SampleInspectionRoutes";
import OAuthNew from "src/welcome/features/oAuthNew/oAuthNew";
import { violationPaths } from "src/routes/ViolationRoutes";
import { supervisoryTeamPaths } from "./routes/SupervisoryTeamRoutes";

/**
 *  /welcome
 */
const welcomePaths: RouteObject = {
  path: "/welcome",
  children: [
    {
      path: "loginForm",
      element: <LandPage />,
    },
    {
      path: "visaMore",
      element: <VisaCardMore />,
    },
    {
      path: "mcMore",
      element: <MasterCardMore />,
    },
    {
      path: "ggpsIntro",
      element: <LandPage />,
    },
    {
      path: "companyNameApproverLogin",
      element: <CompanyNameApproverLogin />,
    },
    {
      path: "oauthHandleForCompanyPerson",
      element: <OauthHandler />,
    },
    {
      path: "oauthHandle",
      element:
        import.meta.env.VITE_OAUTH2_ACTIVATED === "true" ? (
          <OAuthNew />
        ) : (
          <TaxisRegister />
        ),
    },
    {
      path: "reminderCheckEmail",
      element: <ResetPassCheckEmail />,
    },
    {
      path: "oauthHandleForReminder",
      element: <OauthHandlerForReminder />,
    },
    {
      path: "resetPasswordForm",
      element: <ResetPasswordForm />,
    },
    {
      path: "registrationForm",
      element: <RegistrationForm />,
    },
    {
      path: "cookies",
      element: <Cookies />,
    },
    {
      path: "privacyPolicies",
      element: <PrivacyPolicies />,
    },
    {
      path: "reminderForm",
      element: <Reminder />,
    },
  ],
};

const welcomeNonGemiPaths: RouteObject = {
  path: "/welcomeNonGemi",
  children: [
    {
      path: "nonGemiRegistrationForm",
      element: <NonGemiRegistrationForm />,
    },
    {
      path: "checkYourEmail",
      element: <CheckYourEmail />,
    },
    {
      path: "validateEmail",
      element: <ValidateEmail />,
    },
  ],
};

const welcomeGovPaths: RouteObject = {
  path: "/welcomeGovChamber",
  children: [
    {
      path: "login",
      element: <LandPage />,
    },
  ],
};

const welcomeRegionPaths: RouteObject = {
  path: "/welcomeGovRegion",
  children: [
    {
      path: "loginForm",
      element: <LandPage />,
    },
  ],
};

const publicCertificateDownloadRoutes: RouteObject = {
  path: "/publicCertificateDownload",
  children: [
    {
      path: "form",
      element: <PublicCertificateDownloadForm />,
    },
  ],
};

const mailbox: RouteObject = {
  path: "/email",
  children: [
    {
      path: "mailbox",
      element: (
        <RouteProtector allowedUsers={["isBusiness", "isNonGemiUser"]}>
          <Mailbox />
        </RouteProtector>
      ),
    },
    {
      path: "mailbox/:emailType/:id",
      element: (
        <RouteProtector allowedUsers={["isBusiness", "isNonGemiUser"]}>
          <MailboxDetails />
        </RouteProtector>
      ),
    },
  ],
};

const companySuspensionRoutes = {
  path: "/companySuspension",
  children: [
    {
      path: "listOfSuspensions",
      element: (
        <RouteProtector allowedUsers={["isBusiness"]}>
          <ListOfSuspensions />
        </RouteProtector>
      ),
    },
  ],
};

export const router = () => {
  const router = createBrowserRouter([
    {
      path: "/",
      errorElement: (
        <PersistentDrawerLeft>
          <NotFoundPage />
        </PersistentDrawerLeft>
      ),

      element: (
        <BrowserBackProvider>
          <PersistentDrawerLeft />
        </BrowserBackProvider>
      ),
      children: [
        {
          path: "",
          element: <LandPage />,
        },
        {
          path: "error502",
          element: <Error502 />,
        },
        {
          path: "document",
          children: [
            {
              path: "download",
              element: <DocumentDownloadPage />,
            },
          ],
        },
        welcomePaths,
        welcomeNonGemiPaths,
        welcomeRegionPaths,
        businessPaths,
        applicationPaths,
        certificatePaths,
        welcomeGovPaths,
        chamberRoutes,
        paymentPaths,
        nonGemiPaths,
        creditCard,
        namePurchase,
        beneficiaryPaths,
        region,
        mailbox,
        publicCertificateDownloadRoutes,
        companySuspensionRoutes,
        followCompanyPaths,
        adminPaths,
        cashierPaths,
        empaPaths,
        complaintPaths,
        sampleInspectionPaths,
        violationPaths,
        supervisoryTeamPaths,
      ],
    },
  ]);

  return router;
};
